import { render, staticRenderFns } from "./buy-card-modal.vue?vue&type=template&id=2713fb98&scoped=true&lang=pug&%40touchmove=(e)%20%3D%3E%20e.preventDefault()&"
import script from "./buy-card-modal.vue?vue&type=script&lang=js&"
export * from "./buy-card-modal.vue?vue&type=script&lang=js&"
import style0 from "./buy-card-modal.vue?vue&type=style&index=0&id=2713fb98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2713fb98",
  null
  
)

export default component.exports